import { BaseModel } from "./base-model"
import { Contact } from "./contact"
import { PayloadIntegration } from "./integration"
import { Phone } from "./phone"
import { Tag } from "./tag"
import { UploadFile } from "./upload-file"

export enum CallStatus {
    Ongoing = "ongoing",
    Completed = "completed",
    Missed = "missed",
}

export enum CallDirection {
    Incoming = "incoming",
    Outgoing = "outgoing",
}

export enum InboxType {
    EmailMessagingThread = "EmailMessagingThread",
    SMSMessagingThread = "SMSMessagingThread",
    Call = "Call",
}

export enum ContactType {
    Agent = "agent",
    Contact = "contact",
}

export interface Inbox extends BaseModel {
    _id: string
    agencyId: string
    createdById: string
    ownedById: string
    subject?: string
    body: string
    plain: string
    snippet?: string
    contactId?: string
    contactsIds?: string[]
    contact?: Contact
    contacts?: Contact[]
    sentAt: Date
    files: UploadFile[]
    domainId: string
    integration?: PayloadIntegration
    fromPhoneNumber?: Phone
    fromEmail?: string
    from?: Contact
    to?: Contact[]
    toPhoneNumber?: string
    messages?: Inbox[]
    unread?: boolean
    direction?: CallDirection
    status?: CallStatus
    recordingUrl?: string
    tags?: Tag[]
    __t: InboxType
    cc?: string[]
}

export interface InboxContact extends BaseModel {
    fullName?: string
    email?: string
    phone?: Phone
    type?: ContactType
    doNotDisturb?: {
        isEnabled?: boolean
        startDate?: Date
        endDate?: Date
    }
    marketingPreferences?: {
        isEnabledEmailWorkflow: boolean
        isEnabledEmailManual: boolean
        isEnabledMessageWorkflow: boolean
        isEnabledMessageManual: boolean
        isEnabledPhoneCallManual: boolean
        isEnabledAlertWorkflow: boolean
    }
}
